<template>
  <div @click="doClose" :class="{notInDrawer: !getModalStatus(), wrapper: true}" v-if="open">
    <div id="globalCustomModal" :class="{wrapper_body: true}">
      <div :class="{'modal_body': true, 'small': true }">
        <button @click="doClose(null, true)" class="btn btn-default btn-sm position-absolute close_btn" type="button">
          <i class="icon-fa icon-fa-close"></i>
        </button>
        <slot/>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['onClose'],
  data() {
    return {
      open: true,
    }
  },
  methods: {
    getModalStatus() {
      return this.$store.getters['platform/isGlobalDrawerOpen'];
    },
    doClose(e, global = false, useCallBack = false, clearStore = true) {
      if (global || (e && e.target && e.target.id === 'globalCustomModal')) {
        // const body = document.getElementsByTagName('body')[0];
        // body.style.overflow = "auto";
        if (this.onClose) this.onClose();
        this.open = false;
      }
    },
  }
}
</script>

<style scoped>
.notInDrawer {
  padding-top: 60px;
}

.modal_body .main-content {
  padding: 0;
}

.loading_div {
  position: absolute;
  top: 50%;
  left: 50%;
}

.modal_body.small {
  width: 50%;
}

.modal_body {
  background-color: #efefef;
  //background-color: white; height: 100vh; width: 75%; position: absolute; right: 0; padding: 15px; overflow: auto;
}

.wrapper_body.open {
  /*left: calc(100% - 300px);*/
  /*left: 25%;*/
  transition: all 0.3s ease 0s;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  width: 100%;
  /*left: 100%;*/
  min-height: 100%;
  z-index: 9;
  background-color: transparent;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 201;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}

.close_btn {
  right: 5px;
  top: 5px;
  z-index: 11;
}

.modal_body .main-content {
  padding: 0;
  min-height: auto;
}
</style>
